// TODO: Update with actual extension ID once published.
export const EXTENSION_ID = "llnmekdhiiidlehocjhlnajijopclbmo";
export const AUTH_HEADER = "Tiny-Recipe-Box-User-ID";
export const TEST_USER_ID = "e1e1a727-2d92-455e-aed5-e7c5fab979e9";
